import React from "react";
import classNames from "classnames";

import { Button } from "@fourkites/elemental-atoms";

import "./ModalFooter.scss";

import ModalFooterProps from "./ModalFooter.types";

const ModalFooter = ({
  size,
  onClose,
  onSave,
  onAction,
  closeLabel,
  saveLabel,
  actionLabel,
}: ModalFooterProps) => {
  const modalFooterClass = classNames(
    "elemental-modal-footer",
    `modal-${size}`
  );

  return (
    <div className={modalFooterClass} data-testid="elemental-modal-footer">
      {onAction && (
        <div
          data-testid="elemental-modal-footer-action-button"
          className="elemental-modal-footer-button"
        >
          <Button theme="secondary" variant="flat" onClick={onAction}>
            {actionLabel}
          </Button>
        </div>
      )}
      {onClose && (
        <div
          data-testid="elemental-modal-footer-close-button"
          className="elemental-modal-footer-button"
        >
          <Button theme="secondary" onClick={onClose}>
            {closeLabel ? closeLabel : "Cancel"}
          </Button>
        </div>
      )}
      {onSave && (
        <div
          data-testid="elemental-modal-footer-save-button"
          className="elemental-modal-footer-button"
        >
          <Button onClick={onSave}>{saveLabel ? saveLabel : "Update"}</Button>
        </div>
      )}
    </div>
  );
};

export default ModalFooter;
